import type { Tag } from 'lib-shared-types-api';
import { useCallback } from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import { TagSelect } from 'components/tagSelect/tagSelect';

type Props = WrappedFieldArrayProps<Tag> & { disabled?: boolean };

export const TagsSelectFieldArray = ({
  fields,
  disabled,
}: Props): JSX.Element => {
  const selectedTags = fields.getAll() ?? [];

  const handleChange = useCallback(
    (tags: readonly Tag[]) => {
      fields.removeAll();
      tags.forEach((tag) => fields.push(tag));
    },
    [fields],
  );

  return (
    <TagSelect
      selectedTags={selectedTags}
      allowMultiple
      allowTagCreation
      placeholder="Tags"
      onChange={disabled ? undefined : handleChange}
    />
  );
};
